import { useCallback } from 'react';
import { useAIStream } from '@teetsh/app/src/hooks/useAIStream';
import { ImprovementType } from 'components/Editor/AIAssist/types';
import { BoFields } from 'types/bo';
import { Material } from 'types/event';
import { ConversationMessage } from 'components/Editor/AIAssist/hooks/useConversationHistory';
import { AIHook } from 'components/Editor/EditorAIWrapper';

export interface CahierJournalContext {
  bo?: BoFields;
  title?: string;
  flow?: string;
  lengthInMinutes?: number;
  materials?: Material[];
  tagName?: string;
  niveaux?: string;
  cycle?: string;
}

interface Props {
  context?: CahierJournalContext;
  onComplete?: () => void;
}

export function useAIAssistCahierJournal(props: Props = {}): AIHook {
  const { context = {}, onComplete } = props;

  const {
    data,
    error,
    isLoading,
    startGeneration: baseStartGeneration,
    stop,
    reset,
  } = useAIStream('/v0/ai-assist/cahier-journal', {
    onComplete,
  });

  const startGeneration = useCallback(
    ({
      text,
      type,
      userPrompt,
      history,
    }: {
      text: string;
      type: ImprovementType;
      userPrompt?: string;
      history?: ConversationMessage[];
    }) => {
      baseStartGeneration({
        text,
        improvementType: type,
        ...(userPrompt && { userPrompt }),
        ...(history && { history }),
        stream: true,
        context: context || {},
      });
    },
    [baseStartGeneration, context],
  );

  return {
    data,
    error,
    isLoading,
    startGeneration,
    stop,
    reset,
    promptPlaceholder: undefined,
    promptDescription: undefined,
  };
}
